import React from 'react';
import { Box, Typography, Grid, Divider, Chip } from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const ProfileEducation = ({ empData, eduLevels, expRanges }) => {
  
  // Safe JSON parser for arrays (Skills, Certifications, Languages)
  const parseArrayData = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    try {
      const parsed = JSON.parse(data);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      return [data];
    }
  };

  const skills = parseArrayData(empData?.skills);
  const certifications = parseArrayData(empData?.certifications);
  const languages = parseArrayData(empData?.languages);

  // FIX: Added String() wrapper to ensure numbers and strings map perfectly
  const educationName = eduLevels?.find(e => String(e.id) === String(empData?.education_id))?.name || 'Not Provided';
  const experienceName = expRanges?.find(e => String(e.id) === String(empData?.experience_id))?.name || 'Not Provided';

  const DetailItem = ({ label, value }) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
        {label}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
        {value || '--'}
      </Typography>
    </Box>
  );

  const TagList = ({ label, items }) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 1 }}>
        {label}
      </Typography>
      {items.length > 0 ? (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {items.map((item, index) => {
            const displayValue = typeof item === 'object' ? (item.name || item.title || JSON.stringify(item)) : item;
            return <Chip key={index} label={displayValue} size="small" sx={{ bgcolor: '#f1f5f9', fontWeight: 500 }} />;
          })}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">--</Typography>
      )}
    </Box>
  );

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
        <MenuBookIcon color="primary" />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Education & Skills</Typography>
      </Box>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <DetailItem label="Highest Education" value={educationName} />
          <DetailItem label="Total Experience" value={experienceName} />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TagList label="Core Skills" items={skills} />
          <TagList label="Certifications" items={certifications} />
          <TagList label="Known Languages" items={languages} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfileEducation;